import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import { MenuContext } from "../context/MenuContext";
import { TbPigMoney } from "react-icons/tb";
import { BiMoneyWithdraw } from "react-icons/bi";
import Chart from "react-apexcharts";


export default function Home() {
    const navigate = useNavigate();
    const {logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [formFields, setFormFields] = useState({ range: "" });
    const [bookingList, setBookingList] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [offset, setOffset] = useState(0);
    const { menuOpen, setMenuOpen } = useContext(MenuContext)
    const [pageData, setPageData] = useState({});
    const [chartData, setChartData] = useState({categories: [], series: []});

    useEffect(() => {
        if (menuOpen) setMenuOpen(false);
        getData();
    }, [])

    useEffect(() => {
        getData();
    }, [offset, formFields?.range])

    function changePage(type) {
        if (type == "next") {
            setOffset(offset + 20);
        } else {
            setOffset(offset - 20);
        }
    }

    async function getData() {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData.append('offset', offset);
        formData.append('range', formFields?.range);
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/home.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setBookingList(response.data.records);
              setPageData({ total_income: response.data.total_income, total_orders: response.data.total_orders });
              setChartData(response.data.chartData);
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#7d5af6'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, Admin`} />
        <div className="py-6 px-6 flex flex-col justify-start">
            <div className="animate-fadeIn mt-0 w-full bg-white rounded-3xl border p-6 shadow-sm grid grid-cols-2 md:grid-cols-2">
                <div className="flex-1">
                  <label className="flex items-center gap-2 text-gray-500 text-sm mb-1">
                    <TbPigMoney className="w-5 h-5" />
                    Total Sales
                  </label>

                  <div className="relative">
                      <p className="font-bold text-3xl">{pageData?.total_income}</p>
                  </div>
                </div>
                <div className="flex-1">
                  <label className="flex items-center gap-2 text-gray-500 text-sm mb-1">
                    <BiMoneyWithdraw className="w-5 h-5" />
                    Order Count
                  </label>

                  <div className="relative">
                      <p className="font-bold text-3xl">{pageData?.total_orders}</p>
                  </div>
                </div>
            </div>
            <div className="flex mt-7 flex-row items-center justify-between">
                <h2 className="text-xl md:text-2xl text-black font-bold">{'Website Logs'}</h2>
                <div className="flex items-center gap-x-2">
                    <p>Show: </p>
                    <select
                        className="w-auto mx-auto border p-2 rounded my-2"
                        onChange={(e) => setFormFields({...formFields, range: e.target.value})}
                    >
                        <option value="">Past 7 days</option>
                        <option value="Today">Last 24 hours</option>
                        <option value="Week">Past 7 days</option>
                        <option value="Month">Past 30 days</option>
                        <option value="Year">Past 1 Year</option>
                    </select>
                </div>
            </div>
            <div className="flex items-end gap-3 h-auto w-full">
                <div className="mixed-chart w-full">
                    <Chart
                    options={{
                        chart: {
                            id: "basic-bar",
                            type: "line",
                            toolbar: { show: true },
                        },
                        plotOptions: {
                            bar: {
                            borderRadius: 6,
                            columnWidth: '30%',
                            distributed: true, // So you can color individual bars
                            },
                        },
                        colors: ["#000aff", "#00b47a"],
                        dataLabels: {
                            enabled: true,
                        },
                        stroke: {
                            width: [3, 3]
                        },    
                        grid: {
                            show: true,
                            borderColor: '#E5E7EB', // Tailwind gray-200
                            strokeDashArray: 4,
                            padding: { top: 0, right: 0, bottom: 0, left: 0 },
                        },
                        xaxis: {
                            categories: chartData?.categories,
                            axisBorder: { show: true },
                            axisTicks: { show: true },
                            labels: {
                                style: {
                                    colors: '#212121', // Tailwind gray-500
                                    fontSize: '10px',
                                },
                            },
                        },
                        yaxis: {
                            labels: {
                                style: {
                                    colors: '#212121', // Tailwind gray-400
                                    fontSize: '10px',
                                },
                            },
                            axisBorder: { show: false },
                            axisTicks: { show: true },
                        },
                    }}
                    series={chartData?.series}
                    type="line"
                    height="350"
                    // width="500"
                    />
                </div>
            </div>
            <div className="flex mt-7 flex-row items-center justify-between">
                <h2 className="text-xl md:text-2xl text-black font-bold">{'Recent Orders'}</h2>
                <button onClick={() => null } className="bg-primary text-white flex flex-row items-center justify-evenly w-auto h-[35px] px-5 rounded-xl shadow-md shrink-0 text-sm md:text-md font-cormorant-bold">
                    <span className="text-white font-cormorant-bold text-sm md:text-md update-price">View All Orders</span>
                </button>
            </div>
            <div className='overflow-x-auto mt-5'>
                <table className="w-full table-auto border-collapse text-sm md:text-[15px]">
                    <thead className="bg-gray-50 border-b">
                    <tr>
                        <th className="hidden md:table-cell px-2 py-4">
                            <div className="flex items-center gap-1">#</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Reference</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Customer Details</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Order Amount</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Order Summary</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Channel</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Status</div>
                        </th>
                        <th className="hidden md:table-cell text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Time</div>
                        </th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {bookingList?.map((row, index) => (
                            <tr
                            key={index}
                            className={index % 2 === 0 ? "bg-white animate-fadeIn" : "bg-gray-50 animate-fadeIn"}
                            >
                                <td className="hidden md:table-cell px-2 py-2">
                                    {++index}
                                </td>
                                <td className="px-2 py-2">
                                    {row.rrr}
                                </td>
                                <td className="px-2 py-2 flex flex-col">
                                    <a className="font-semibold text-sm">{row.full_name}</a>
                                    <a className="text-xs">{row.email}</a>
                                    <a className="text-xs">{row.phone_number}</a>
                                </td>
                                <td className="px-2 py-2">
                                    {row.order_amount}
                                </td>
                                <td className="px-2 py-2 flex flex-col">
                                    {row.order_items?.map((item, index) => 
                                        <a className="text-sm">{++index}{". "}{item.name}</a>
                                    )}
                                </td>
                                <td className="hidden md:table-cell px-2 py-2">
                                    {row.channel}
                                </td>
                                <td className="px-2 py-2 text-sm">
                                    {row.isFulfilled && <div className="p-3 py-1 font-medium rounded-lg bg-[#00b47a]/20 text-[#00b47a]">Fulfilled</div>}
                                    {!row.isFulfilled && <div className="p-3 py-1 font-medium rounded-lg bg-secondary/20 text-secondary">Pending</div>}
                                </td>
                                <td className="hidden md:table-cell px-2 py-2">
                                    {row.time}
                                </td>
                                <td className="px-2 py-2">
                                    {row.rrr !== "" && <div className="flex flex-col md:flex-row gap-y-1 md:gap-y-0 gap-x-1">
                                        <div onClick={() => navigate(`/dashboard/order-history/details/${row.rrr}`)} className="flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-primary bg-primary text-white font-semibold text-center text-xs">{'View'}</div>
                                    </div>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  );
}
